var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button_add mb-4" }, [
    _c(
      "button",
      {
        staticClass:
          "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
        on: {
          click: function ($event) {
            return _vm.add_time()
          },
        },
      },
      [
        _c("span", { staticClass: "fal fa-eject mr-1" }),
        _vm._v("\n            " + _vm._s(_vm.__t("ADD")) + "\n    "),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "time_info" }, [
      _c(
        "ul",
        { staticClass: "list-style-none" },
        _vm._l(this.times_work, function (item, idx) {
          return _c("li", { staticClass: "mt-2 list-style-none" }, [
            _c("div", { staticClass: "row row-no-padding" }, [
              _c(
                "div",
                { staticClass: "col-5" },
                [
                  _c("b-form-timepicker", {
                    key: "t_".idx,
                    staticClass: "mb-2",
                    model: {
                      value: item.start,
                      callback: function ($$v) {
                        _vm.$set(item, "start", $$v)
                      },
                      expression: "item.start",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-5" },
                [
                  _c("b-form-timepicker", {
                    key: "e_".idx,
                    staticClass: "mb-2",
                    model: {
                      value: item.end,
                      callback: function ($$v) {
                        _vm.$set(item, "end", $$v)
                      },
                      expression: "item.end",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(idx)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.__t("REMOVE")) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }